export const NOISE_SUPPRESSION_AUDIO_WORKLET_DEV_MODULE_URL =
  "/node_modules/@workadventure/noise-suppression/dist/assets/audio-worklet-processor.js";
